<template>
<div class="zym-login">

    <img class="logo" src="../assets/bg-head.png">
    <div class="zym-title">手机助手</div>
    <div class="mobile">
      <div class="zym-field-icon">
        <img src="../assets/icon-login-user.png">
      </div>
      <div class="zym-cell">
        <input   placeholder="请输入登录名" v-model="loginForm.username" class="van-field-control">
      </div>
    </div>
    <div class="mobile">
      <div class="zym-field-icon">
        <img src="../assets/icon-login-suo.png">
      </div>
      <div class="zym-cell">
        <input type="password"  placeholder="请输入密码"  v-model="loginForm.password" lass="van-field-control">
      </div>
    </div>
    <div class="login-button">
      <span v-on:click="loginByUsername">登录</span>
      <span class="btn-green" v-if="loginShow"  @click="wxLogin()">微信一键登录</span>
    </div>
    <div class="desc">湖南惠农科技有限公司</div>

  </div>


</template>

<script>
import { encryption } from "@/api/login";
import { loginUser } from "@/api/bapi";
import { getinfo } from "@/api/bapi";
export default {
  name: "Login",
  data() {
    return {
      isSpinShow: false,
      showTip1: false,
      showTip2: false,
      yzm: "",
      tipText1: "",
      tipText2: "",
      username: "",
      password: "",
      img: "",
      loginForm: {
        username: "",
        password: "",
        code: "",
        randomStr: "",
        grant_type: "password",
        scope: "server"
      },
      userInfo: "",
      loginShow: false
    };
  },
  created() {
    this.loginShow = false;
    var u = navigator.userAgent;
    let vue = this;
    if (u.indexOf("MicroMessenger") > 0) {
      this.loginShow = true;
    }

    if (localStorage.getItem("loginUserInfo")) {
      this.$axios({
        headers: {
          Authorization:
            localStorage.getItem("token_type") +
            localStorage.getItem("access_token")
        },
        method: "get",
        url: "admin/user/loginInfo"
      })
        .then(res => {
          if (res.status == 200) {
            if (res.data.code == 0) {
              if (!res.data.data.org) {
                that.$Message.error("登录失败，请确认您的账号为企业帐号");
              } else if (res.data.data.org.instituteForm == 2) {
                that.$Message.error("登录失败，请确认您的账号为企业帐号");
              } else {
                that.$Message.success("登录成功");
                localStorage.setItem(
                  "loginUserInfo",
                  JSON.stringify(res.data.data)
                );
                that.$router.push("/index");
              }
            }
          }
        })
        .catch(err => {});
    }
  },
  computed: {
    httpUrl() {
      return this.$store.state.httpUrl;
    }
  },
  methods: {
    wxLogin() {
      window.location = this.httpUrl + "/portal/webchat/login";
    },
    loginByUsername() {
      var that = this;
      this.isSpinShow = true;
      const user = encryption({
        data: this.loginForm,
        key: "thanks,pig4cloud",
        param: ["password"]
      });
      // 11.22 进行修改下面两行
      console.log(this.$axios.defaults);
      this.$axios.defaults.baseURL = 'http://gateway.zhenyuanma.com';//20210204 zym.so换成zhenyuanma.com
      loginUser(user)
        .then(res => {
          if (res.status == 200) {
            localStorage.setItem("access_token", res.data.access_token);
            localStorage.setItem("refresh_token", res.data.refresh_token);
            localStorage.setItem("token_type", res.data.token_type);
            this.$axios({
              headers: {
                Authorization:
                  localStorage.getItem("token_type") +
                  localStorage.getItem("access_token")
              },
              method: "get",
              url: "admin/user/loginInfo"
            })
              .then(res => {

                if (res.status == 200) {
                  if (res.data.code == 0) {
                    if (!res.data.data.org) {
                      that.$Message.error("登录失败，请确认您的账号为企业帐号");
                    } else if (res.data.data.org.instituteForm == 2) {
                      that.$Message.error("登录失败，请确认您的账号为企业帐号");
                    } else {
                      that.$Message.success("登录成功");
                      localStorage.setItem(
                        "loginUserInfo",
                        JSON.stringify(res.data.data)
                      );
                      console.log(localStorage.getItem("loginUserInfo"));
                      that.$router.push("/index");
                    }
                  } else {
                    that.$Message.error(res.data.msg);
                  }
                } else {
                  that.$message.error("网络错误，请稍候再试");
                }
              })
              .catch(err => {
                that.$message.error("你目前没有平台权限");
                that.isSpinShow = false;
              });
          } else {
            that.isSpinShow = false;
            that.$Message.error(res.data.msg);
          }
        })
        .catch(function(reason) {
          console.log(reason);
          that.isSpinShow = false;
          that.$Message.error("用户名不存在或密码错误");
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.zym-login {
  position: relative;
  min-width: 100vw;
  min-height: 100vh;
  background-color: #fff;
}
.zym-login .logo {
  display: block;
  width: 100%;
  height: 120px;
  object-fit: cover;
  object-position: center;
}
.zym-login .zym-title {
  margin: 10px 10px 50px 10px;
  color: #39BF3E;
  font-size: 20px;
  text-align: center;
}
  .zym-login .mobile {
    display: flex;
    align-content: space-between;
    margin: 15px 50px 0 50px;
  }
.zym-login .mobile .zym-field-icon {
  position: relative;
  top: 10px;
  width: 14px;
  height: 14px;
}
.zym-login .mobile .zym-field-icon img {
    display: block;
  width: 100%;
  height: 100%;
  }
.zym-login .mobile .zym-cell {
  flex: 1;
    margin-left: 12px;
    line-height: 30px;
    border-bottom: 1px solid #ddd;
  }
.zym-login .mobile .zym-cell input {
  font-size: 14px;
  color: #333;
  outline:none;
}
  .zym-login .login-button {
    margin: 35px 37px 0 37px;
  }
.zym-login .login-button span {
  display: block;
  height: 40px;
  line-height: 40px;
  font-size: 17px;
  color: #39BF3E;
  text-align: center;
  border: 1px solid #909090;
  border-radius: 20px;
}
.zym-login .login-button span:nth-child(2) {
  margin-top: 10px;
}
.zym-login .login-button .btn-green {
    color: #fff;
    background-color: #39BF3E;
    border: 1px solid #39BF3E;
  }
  .zym-login .desc {
    position: absolute;
    bottom: 15px;
    left: 0;
    width: 100%;
    color: #909090;
    font-size: 12px;
    text-align: center;
  }

input::-webkit-input-placeholder {
  color: #ddd;
}
input:-moz-placeholder {
  color: #ddd;
}
input::-moz-placeholder {
  color: #ddd;
}
input:-ms-input-placeholder {
  color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue